/**
 * @module admin/dashboards/design/store
 *
 * Vuex module for admin/dashboards/design
 */

export * from './actions';
export * from './mutations';
export { state } from './state';

export const namespaced = true;
